module.exports = {
    NAME_CONSTANTS: {
        namePrefix: 'PREFIX',
        givenName: 'FIRSTNAME',
        middleName: 'MIDDLENAME',
        surname: 'LASTNAME',
        nameSuffix: 'SUFFIX',
        altName: 'ALT_NAME'
    },
    DATE_CONSTANTS: {
        US: {
            PAYOUT_DATE: '25',
        },
        CA: {
            PAYOUT_DATE: '30',
        }
    },
    PAGE_CONSTANTS: {
        INTIAL_PAGE_NO: '1',
        PAGE_SIZE_TEN: '10',
        PPGF_ACC_CLOSED: 'Closed',
        PPGF_ACC_CONFIRMED: 'confirmed',
        PAGES: {
            DASHBOARD: 'dashboard',
            CLOSED_ACC: 'closed-acc',
            GRANT: 'GRANT',
            GRANT_MAKER: 'GRANT_MAKER'
        },
        IS_REFUNDS: ['1', '2'],
        AMOUNT_SIGN: {
            PLUS: 'pos',
            MINUS: 'neg'
        },
        NONPROFIT_MCCCODE: 8398
    },
    ERR_CONSTANTS: {
        desc: 'descError',
        missionArea: 'missionAreaError',
        phone: 'phoneError',
        keywords: 'keywordsError',
        cta: 'ctaError',
        email: 'emailError',
        email2: 'email2Error',
        firstName: 'firstNameError',
        lastName: 'lastNameError'
    },
    ROUTE_PATH: {
        ACTIVITY: ['/activity', '/activity/'],
        PROFILE: ['/profile', '/profile/'],
        DASHBOARD: ['/dashboard', '/dashboard/'],
        DEFAULT_PATH: ['/'],
        HOME_PAGE: ['/home', '/home/'],
        OBS_URL: ['/preenroll', '/preenroll/'],
        TERMS_CONDITIONS: ['/termsandconditions', '/termsandconditions/'],
        POLICIES: ['/policies', '/donation-delivery', '/donation-refunds', '/user-agreement',
            '/privacy', '/nonprofit-certification', '/non-profits', '/item-cancellation',
            '/policies/', '/donation-delivery/', '/donation-refunds/', '/user-agreement/',
            '/privacy/', '/nonprofit-certification/', '/non-profits/', '/item-cancellation/'],
        ENROLL: ['/enrollInPPGF', '/transferCode', '/enroll'],
        HELP_REDIRECTS: ['/charity', '/donors', '/faq', '/charity/', '/donors/', '/faq/'],
        ABOUT_REDIRECT: ['/about', '/about/'],
        CONTACT_REDIRECT: ['/contact', '/contact-confirmation', '/contact/', '/contact-confirmation/'],
        PARTNER_LIST: ['/partner-list', '/partner-list/']
    },
    ENROLL_CHAR_COUNT: {
        DESCRIPTION: 400,
        KEYWORDS: 200,
        SLOGAN: 90
    },
    FB_FUNDRAISING_COUNTRIES: ['AU', 'CA', 'GB'],
    EBAY_PPHERE_COUNTRIES: ['US', 'GB'],
    AUTO_ENROLL_COUNTRIES: ['CA', 'IE'],
    DOWNLOAD_FIELDS: {
        PAYOUT_ALP_FIELDS: ['payoutDate', 'donationDate', 'donorFirstName', 'donorLastName',
            'donorEmail', 'program', 'referenceInformation', 'currencyCode', 'grossAmount', 'totalFees', 'netAmount'],
        PAYOUT_ALP_HEADER: ['Payout Date', 'Donation Date', 'Donor First Name', 'Donor Last Name', 'Donor Email', 'Program Name', 'Reference Information', 'Currency Code', 'Gross Amount', 'Total Fees', 'Net Amount'],
        PAYOUT_FIELDS: ['payoutDate', 'donationDate', 'donorName', 'donorEmail', 'program', 'campaignTitle', 'eBayListingId', 'currencyCode', 'amount'],
        PAYOUT_HEADER: ['Payout Date', 'Donation Date', 'Donor Name', 'Donor Email', 'Program', 'Campaign Title', 'eBay Listing ID', 'Currency Code', 'Amount'],
        DONATIONS_FIELDS: ['donationDate', 'donorFirstName', 'donorLastName',
            'donorEmail', 'program', 'referenceInformation', 'currencyCode', 'grossAmount', 'totalFees', 'netAmount'],
        DONATION_HEADER: ['Date', 'Donor First Name', 'Donor Last Name', 'Donor Email', 'Program Name', 'Reference Information', 'Currency Code', 'Gross Amount', 'Total Fees', 'Net Amount'],
        GRANT_FIELDS: ['payoutDate', 'expiryDate', 'grantPayoutId', 'recommendedBy', 'email', 'grantMakerName', 'address', 'purpose', 'notes', 'attribution', 'payoutStatus', 'declineReason', 'amount', 'currencyCode'],
        GRANT_HEADER: ['Date Issued', 'Expiry Date', 'Grant Payment ID', 'Recommended By', 'Email', 'Grant Maker', 'Address', 'Purpose', 'Notes', 'Additional Info', 'Status', 'Decline Reason', 'Grant Amount', 'Currency Code'],
        GRANT_MAKER_FIELDS: ['payoutDate', 'expiryDate', 'grantPayoutId', 'recommendedBy', 'email', 'nonProfitName', 'address', 'purpose', 'notes', 'attribution', 'payoutStatus', 'declineReason', 'amount', 'currencyCode'],
        GRANT_MAKER_HEADER: ['Date Issued', 'Expiry Date', 'Transaction ID', 'Recommended By', 'Email', 'Charity', 'Address', 'Purpose', 'Notes', 'Additional Info', 'Status', 'Decline Reason', 'Grant Amount', 'Currency Code']
    },
    AUTO_ENROLL_FIELDS: {
        DECISION_MANUAL: 'MANUAL',
        DECISION_PENDING: 'PENDING',
        DECISION_REJECTED: 'REJECTED',
        DECISION_ENROLLED: 'ENROLLED',
        DECISION_NOT_ELIGIBLE: 'NOT_ELIGIBLE',
        CREATE_OR_UPDATE_PPGF_INTENT: 'CREATE_OR_UPDATE_GIVING_FUND',
        DIRECT_MODEL_ENROLLMENT_OPERATIONS: 'DIRECT_MODEL_ENROLLMENT_OPERATIONS',
        PPGF_SUBMIT_ENROLL_STATUS: 'CREATED',
        PPGF_STATUS_CLOSED: 'DELETED',
        PPGF_ENROLLED: 'PPGF_ENROLLED'
    },
    SMARTHELP_NONPROFIT_COUNTRIES: ['CA', 'AU', 'GB'],
    SMARTHELP_FAQ_COUNTRIES: ['US'],
    SMARTHELP_WEB_FORM: ['IE'],
    TAX_IDENTIFIER_LABEL: { GB: 'Charity commission number', AU: 'ABN', IE: 'Charity number', CA: 'CRA number', US: 'EIN', DEFAULT: 'Tax ID number' },
    ACCOUNT_TYPE: { BUSINESS: 'BUSINESS' },
    LIMITATION_STATUS: { ACTIVE: 'ACTIVE', APPEAL_DENIED: 'APPEAL_DENIED' },
    DATE_DM_LEGAL_UPDATE: '2022-06-17',
    GRANTS_PAYOUT_STATUS: [
        {
            label: 'ALL',
            id: '0',
            grant: true,
            grant_maker: true,
            badge: {
                grant: 'neutral',
                grant_maker: 'neutral',
            },
            search_value: {
                grant: '',
                grant_maker: '',
            }
        },
        {
            label: 'PENDING',
            id: '1',
            grant: true,
            grant_maker: true,
            badge: {
                grant: 'warning',
                grant_maker: 'warning',
            },
            search_value: {
                grant: 'PENDING',
                grant_maker: 'PENDING',
            }
        },
        {
            label: 'PROCESSING',
            id: '2',
            grant: true,
            grant_maker: true,
            badge: {
                grant: 'feature',
                grant_maker: 'feature',
            },
            search_value: {
                grant: 'PROCESSING',
                grant_maker: 'PROCESSING',
            }
        },
        {
            label: 'COMPLETED',
            id: '3',
            grant: true,
            grant_maker: true,
            badge: {
                grant: 'success',
                grant_maker: 'success',
            },
            search_value: {
                grant: 'COMPLETED',
                grant_maker: 'COMPLETED',
            }
        },
        {
            label: 'EXPIRED',
            id: '4',
            grant: true,
            grant_maker: true,
            badge: {
                grant: 'neutral',
                grant_maker: 'neutral',
            },
            search_value: {
                grant: 'EXPIRED',
                grant_maker: 'EXPIRED',
            }
        },
        {
            label: 'CANCELLED',
            id: '5',
            grant: true,
            grant_maker: true,
            badge: {
                grant: 'neutral',
                grant_maker: 'neutral',
            },
            search_value: {
                grant: 'CANCELLED',
                grant_maker: 'CANCELLED',
            }
        },
        {
            label: 'FAILED',
            id: '6',
            grant: true,
            grant_maker: true,
            badge: {
                grant: 'neutral',
                grant_maker: 'neutral',
            },
            search_value: {
                grant: 'RETURNED,FAILED',
                grant_maker: 'FAILED',
            }
        },
        {
            label: 'UNCLAIMED',
            id: '7',
            grant: true,
            grant_maker: true,
            badge: {
                grant: 'neutral',
                grant_maker: 'critical',
            },
            search_value: {
                grant: 'UNCLAIMED',
                grant_maker: 'UNCLAIMED',
            }
        },
        {
            label: 'RECALLED',
            id: '8',
            grant: true,
            grant_maker: true,
            badge: {
                grant: 'neutral',
                grant_maker: 'neutral',
            },
            search_value: {
                grant: 'RECALLED',
                grant_maker: 'RECALLED',
            }
        },
        {
            label: 'INVALID',
            id: '9',
            grant: false,
            grant_maker: true,
            badge: {
                grant: 'neutral',
                grant_maker: 'neutral',
            },
            search_value: {
                grant: 'INVALID',
                grant_maker: 'INVALID',
            }
        },
        {
            label: 'RETURNED',
            id: '10',
            grant: false,
            grant_maker: true,
            badge: {
                grant: 'neutral',
                grant_maker: 'neutral',
            },
            search_value: {
                grant: 'RETURNED,FAILED',
                grant_maker: 'RETURNED',
            }
        }
    ],
    RECALL_CS_NUMBER: '(855)-587-6534',
    GRANT_SEARCH_PERIOD: 31,
    PPGF_XB_CURRENCY_CODE: 'EUR',
    MONTH_ARRAY: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    DAY_ARRAY: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
    BRAZIL: 'BR',
    PPCC_BENEFITS_HEADERFOOTER:['US','GB']
};
